import { AmplifyUser } from "@aws-amplify/ui";
import { Customer } from "../../../api/customer";

export type Keys = {
  apiKey?: string;
  clientApiKey?: string;
};

type BaseAppState = {
  keys?: Keys;
  authToken?: string;
  customer?: Customer;
  user?: AmplifyUser;
};

export type AppState =
  | (BaseAppState & { isLoaded: false })
  | (Required<Omit<BaseAppState, "user">> & Pick<BaseAppState, "user"> & { isLoaded: true });

export enum AppStateActionType {
  update,
}

export interface AppStateAction {
  type: AppStateActionType;
  newState: BaseAppState | AppState;
}

export const reducer = (state: AppState, action: AppStateAction) => {
  switch (action.type) {
    case AppStateActionType.update:
      return {
        ...state,
        ...action.newState,
      };

    default:
      return state;
  }
};

export const initialState: AppState = {
  isLoaded: false,
};
